export default class InteractionConst {
    static GET_PROPERTY_VALUE = 'getvalue'
    static SET_PROPERTY_VALUE = 'setvalue'    
    static GET_VMODEL = 'getvmodel'
    static SET_VMODEL = 'setvmodel'    
    static CALL_FUNCTION = 'callproc'
  }
  